import React from 'react';
import {TranslationMixin} from '../../mixins';
import {WithCommonTranslations} from '../hocs';

import './OrderInvoiceModal.css';

export const OrderInvoiceRefund = WithCommonTranslations(
    class OrderInvoiceRefund extends TranslationMixin(React.Component) {

      renderRefund(refund, creditNote) {
        return (
            <div key={refund.timestamp} className="refund-item">
              {creditNote && <p className="font-weight-bold">{creditNote}</p>}
              <div>{refund.refundDateTime}</div>
              {refund.refundItems && refund.refundItems.length > 0 &&
              <table className='table'>
                <thead>
                <tr>
                  <th>{this.getTranslation('LABEL_DESCRIPTION')}</th>
                  <th className='text-right'>{this.getTranslation(
                      'LABEL_REFUND')}</th>
                </tr>
                </thead>
                <tbody>
                {refund.refundItems.map(item => (
                    <React.Fragment key={item.itemId}>
                      <tr className="refund-item-row">
                        <td>
                          <strong>{item.name}</strong> {item.skuDescription &&
                        <span>- {item.skuDescription}</span>}</td>
                        <td className="text-right">{item.refund}</td>
                      </tr>

                      {item.taxRefundDetails && item.taxRefundDetails.map((tax) => (
                          <tr key={tax.taxType}>
                            <td>
                              {tax.taxType}
                              <span className="ml-1 font-italic">{tax.message}</span>
                            </td>
                            <td className="text-right">
                            {tax.taxRefundedAmount}
                            </td>
                          </tr>
                      ))}
                    </React.Fragment>
                ))}
                </tbody>
              </table>
              }

              <div className="clearfix">
                <table className="float-right total-table">
                  <tbody>
                  <tr>
                    <td>{this.getTranslation('LABEL_ORDER_SUBTOTAL_REFUNDED')}</td>
                    <td className="text-right">{refund.subtotalRefunded}</td>
                  </tr>
                  {this.renderTaxSummary(refund.summaryTaxRefundDetails)}
                  <tr>
                    <td>{this.getTranslation('LABEL_TAX_REFUNDED')}</td>
                    <td className="text-right">{refund.taxRefunded}</td>
                  </tr>
                  <tr className="border-top">
                    <td>{this.getTranslation(
                        'LABEL_TOTAL_REFUND')}</td>
                    <td className="text-right">{refund.totalRefunded}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
        );

      }

      renderTaxSummary(summaryTaxDetails) {
        if (summaryTaxDetails) {
          return summaryTaxDetails.map(d =>
              (<tr key={d.taxType}>
                <td className="font-weight-normal">
                  {d.taxType}
                </td>
                <td className="text-right">{d.taxRefundedAmount}</td>
              </tr>)
          );
        }
      }

      render() {
        const {receiptRefunds, creditNote} = this.props;

        if (!receiptRefunds || receiptRefunds.length === 0) {
          return '';
        }
        return (
            <div className="clearfix refund-box">
              <div className="refund-title">{this.getTranslation(
                  'HEADER_ADJUSTMENTS')}</div>

              {receiptRefunds.map(refund => this.renderRefund(refund, creditNote))}
            </div>
        );
      }
    });